import type {
    SubscriptionProduct,
    SubscriptionProductId,
} from '@fruitful/types';

import { requestBuilder } from '../../http/RequestBuilder';

export type SubscriptionProductCatalog = Partial<
    Record<SubscriptionProductId, SubscriptionProduct>
>;

export const useGetSubscriptionProductCatalog = requestBuilder.query<
    SubscriptionProductCatalog,
    { subscriptionProductIds: SubscriptionProductId[] }
>({
    endpoint: ({ subscriptionProductIds }) =>
        `/api/billing/subscription-products?subscriptionProductIds=${subscriptionProductIds.join(',')}`,
    queryKey: ({ subscriptionProductIds }) =>
        `subscriptionProductCatalog/${subscriptionProductIds.join(',')}`,
});
